<app-form-input-wrapper [control]="formControl">
  <div
    class="rounded-md shadow-sm ring-outline ring-1 bg-surface overflow-hidden"
    [class.!bg-surface-hover]="isDisabled"
    [ngClass]="{ 'ring-red-400 focus:ring-red-400 focus:ring-2': errors | async }"
  >
    <div class="relative overflow-auto">
      <table class="min-w-full table-fixed divide-y divide-separator border-b">
        <thead>
          <tr>
            @if (mode === 'selecting') {
              <th scope="col" class="relative px-7 sm:w-12 sm:px-6"></th>
            }
            <th
              scope="col"
              class="min-w-[12rem] py-3.5 pr-3 text-left text-sm font-semibold text-fg-primary"
              [class.pl-3]="mode === 'sorting'"
            >
              Position
            </th>
            <th scope="col" class="px-3 py-3.5 text-sm text-right font-semibold text-fg-primary">
              Menge
            </th>
            <th scope="col" class="px-3 py-3.5 text-sm text-left font-semibold text-fg-primary">
              Einheit
            </th>
            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-fg-primary text-right">
              Preis/Einheit
            </th>
            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-fg-primary text-right">
              MwSt.
            </th>
            <th scope="col" class="px-3 py-3.5 text-sm font-semibold text-fg-primary text-right">
              Summe
            </th>
            @if (mode === 'sorting') {
              <th
                scope="col"
                class="px-3 py-3.5 text-sm font-semibold text-fg-primary text-right w-16"
              ></th>
            }
          </tr>
        </thead>
        <tbody class="divide-y divide-separator">
          @for (position of _invoicePositions; track position.positionId) {
            @if (position.source === 'manual') {
              <tr
                app-free-position-row
                [position]="position"
                [isDisabled]="isDisabled"
                (editPosition)="editPosition.emit($event)"
                (deletePosition)="deleteRow($event)"
              ></tr>
            } @else {
              @switch (position.unit) {
                @case ('hours') {
                  <tr
                    app-time-material-row
                    [showCheckboxes]="mode === 'selecting'"
                    [position]="position"
                    [isChecked]="value?.positionsSort?.includes(position.positionId) ?? false"
                    [isDisabled]="isDisabled"
                    (positionSelected)="positionSelected(position, $event)"
                    (deletePosition)="deleteRow($event)"
                  ></tr>
                }
                @case ('fixedPrice') {
                  <tr
                    app-fixed-price-row
                    [position]="position"
                    [isDisabled]="isDisabled"
                    [showCheckboxes]="mode === 'selecting'"
                    (deletePosition)="deleteRow($event)"
                  ></tr>
                }
              }
            }
          }
        </tbody>
      </table>
      @if (invoiceSummary) {
        <table class="table-fixed mt-8 ml-auto" [class.mr-[32px]]="mode === 'sorting'">
          <tbody>
            <tr>
              <td class="whitespace-nowrap px-3 text-sm font-medium text-fg-subtle tabular-nums">
                Zwischentotal
              </td>
              <td
                class="whitespace-nowrap px-3 font-medium text-sm text-fg-subtle text-right tabular-nums"
              >
                {{ invoiceSummary.netAmount | formatAmount }}
              </td>
            </tr>
            @for (vat of invoiceSummary.vat; track vat) {
              <tr>
                <td
                  class="whitespace-nowrap px-3 text-sm font-medium text-fg-secondary tabular-nums"
                >
                  {{ vat.rate | formatPercent }}% MwSt
                </td>
                <td
                  class="whitespace-nowrap px-3 text-sm font-medium text-fg-secondary text-right tabular-nums"
                >
                  {{ vat.amount | formatAmount }}
                </td>
              </tr>
            }
            <tr>
              <td class="whitespace-nowrap px-3 text-sm font-medium text-fg-primary tabular-nums">
                Total inkl. MwSt
              </td>
              <td
                class="whitespace-nowrap px-3 py-2 text-sm font-medium text-fg-primary text-right tabular-nums"
              >
                {{ invoiceSummary.totalAmount | formatAmount }}
              </td>
            </tr>
          </tbody>
        </table>
      }
    </div>
  </div>
</app-form-input-wrapper>
